module.exports = __webpack_public_path__ + "img/card.7009485f.svg";